import { Paper, SvgIconTypeMap, Typography } from "@mui/material"
import { OverridableComponent } from "@mui/material/OverridableComponent"
import React, { useMemo } from "react"
import { customPalette } from "../../../../../../../theme"
import { greenSelectableStyle } from "../../../../../../core/services/helper-service"

interface IProps {
  title: string
  isSelectedTab?: boolean
  icon: OverridableComponent<SvgIconTypeMap<unknown, "svg">>
  disabled?: boolean
  onClick(): void
}

export function ControlTabPanel({
  title,
  icon: Icon,
  isSelectedTab,
  disabled,
  onClick,
}: Readonly<IProps>): React.JSX.Element {
  const rowSelectableStyle = useMemo(() => greenSelectableStyle(isSelectedTab ?? false), [isSelectedTab])

  return (
    <Paper
      onClick={disabled || isSelectedTab ? undefined : onClick}
      sx={{
        ...rowSelectableStyle,
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        borderRadius: "14px",
        color: customPalette.darkBlue3,
        gap: "8px",
        p: 2,
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.08)",
        transition: "all 0.2s ease-in-out",
      }}>
      <Icon />
      <Typography variant="subtitle2" fontSize={14}>
        {title}
      </Typography>
    </Paper>
  )
}
